module.exports = __webpack_public_path__ + "bluecore.jpg?a61a79e7db472ad2e13b9b55bae99d1d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projetos/bluecore.jpg
// module id = 106
// module chunks = 0